import React from 'react';
import PropTypes from 'prop-types';

function IconMyBeatport({ color = '#B3B3B3', size = 24, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.8135 6.2377C18.4213 5.84531 17.9557 5.53404 17.4431 5.32168C16.9306 5.10931 16.3813 5 15.8265 5C15.2717 5 14.7223 5.10931 14.2098 5.32168C13.6973 5.53404 13.2316 5.84531 12.8394 6.2377L12.0254 7.05166L11.2115 6.2377C10.4192 5.44548 9.34475 5.00041 8.22437 5.00041C7.104 5.00041 6.02951 5.44548 5.23729 6.2377C4.44507 7.02993 4 8.10441 4 9.22479C4 10.3452 4.44507 11.4196 5.23729 12.2119L6.05125 13.0258L12.0254 19L17.9996 13.0258L18.8135 12.2119C19.2059 11.8197 19.5172 11.354 19.7296 10.8415C19.9419 10.3289 20.0513 9.77958 20.0513 9.22479C20.0513 8.67 19.9419 8.12064 19.7296 7.60811C19.5172 7.09558 19.2059 6.6299 18.8135 6.2377V6.2377Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconMyBeatport.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconMyBeatport;
